module.exports = __webpack_public_path__ + "img/banner05_info1.c9637881.svg";